function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "remote") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 404",
    d: "M31.672 8.91h1.987v1.852h-.673a.213.213 0 0 0-.168.337l1.145 1.28a.189.189 0 0 0 .3 0L35.41 11.1c.135-.135.034-.337-.168-.337H34.6v-1.92a.941.941 0 0 0-.943-.943h-2.052a.518.518 0 0 0-.505.505.6.6 0 0 0 .572.505z",
    transform: "translate(-16.1 -1.421)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 405",
    d: "M8.717 31.219H6.73v-1.852h.67a.213.213 0 0 0 .168-.337l-1.145-1.28a.189.189 0 0 0-.3 0l-1.144 1.28c-.135.135-.034.337.168.337h.64v1.919a.941.941 0 0 0 .943.943h2.054a.518.518 0 0 0 .505-.505.641.641 0 0 0-.572-.505z",
    transform: "translate(-.597 -14.844)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 406",
    d: "M10.26 1.741A.747.747 0 0 0 9.519 1H1.741A.747.747 0 0 0 1 1.741v4.04h9.26z",
    transform: "translate(2.002 2)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 407",
    d: "M10.26 16.906V16.3H1v.606a.747.747 0 0 0 .741.741h7.778a.747.747 0 0 0 .741-.741z",
    transform: "translate(2.002 -8.216)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 408",
    d: "M12.415 22.041a.374.374 0 0 0-.37-.37h-.572V21.3h-2.93v.37H7.97a.37.37 0 1 0 0 .741h4.074a.4.4 0 0 0 .371-.37z",
    transform: "translate(-2.376 -11.554)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 409",
    d: "M30.019 25.5h-7.778a.747.747 0 0 0-.741.741v4.041h9.26v-4.041a.747.747 0 0 0-.741-.741z",
    transform: "translate(-9.762 -12.392)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 410",
    d: "M21.5 41.306a.747.747 0 0 0 .741.741h7.778a.747.747 0 0 0 .741-.741V40.7H21.5z",
    transform: "translate(-9.762 -22.528)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "fillable-area",
    "data-name": "Path 411",
    d: "M32.545 46.17h-.572v-.37h-2.93v.37h-.573a.37.37 0 1 0 0 .741h4.074a.374.374 0 0 0 .37-.37.353.353 0 0 0-.369-.371z",
    transform: "translate(-14.139 -25.911)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemote);
export default __webpack_public_path__ + "static/media/remote.06246dd4b5129594c35c661f64a0d316.svg";
export { ForwardRef as ReactComponent };